import React, { useState, useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { PATTERNS } from "../../../../util/patterns";
import { stateList } from "../../../../util/CommonLists";
import BillingInformationCustomMessage from "./BillingInformationCustomMessage";
import * as service from "../../../../store/service";
import { Notification } from "../../../common/Notification";
import { CAProvinces } from "../../../../util/CommonLists";
import i18nService from "../../../../util/Internationalization/i18n/i18n";
import PhoneInput, { parsePhoneNumber } from "react-phone-number-input";
import RenderIcons from "../../../../Assets/css/_icons/partner_icon/RenderIcons";
import { ApplicationState } from "../../../../store";
import { useSelector } from "react-redux";
import { isValidPhoneNo } from "../../../../util/phoneNumberValidationUtil";
import { validateCardExpiry } from "../../../../util/common";
import { useTranslation } from "react-i18next";

interface IProps {
    setShowForm: any;
    billingInfo: any;
    IsIDFUser: any;
    setEFTDialog: any;
    contactInfo: any;
    setBillingInfo: any;
    setHasbillingInfo: any;
}

const BillingInformationForm = ({ setShowForm, billingInfo, IsIDFUser, setEFTDialog, contactInfo, setBillingInfo, setHasbillingInfo }: IProps) => {
    const CC = "CC";
    const EFT = "EFT";

    const isCreditCardAllowed = billingInfo.paymentMethod && billingInfo.paymentMethod.options && billingInfo.paymentMethod.options.includes(CC);
    const isEFTAllowed = billingInfo.paymentMethod && billingInfo.paymentMethod.options && billingInfo.paymentMethod.options.includes(EFT);

    const [loading, setLoading] = useState(false);
    const [isETF, setIsETF] = useState(false);
    const [isEFTChecked, setIsETFChecked] = useState(false);
    const [isSameAsContactAddress, setIsSameAsContactAddress] = useState(false);
    const [state, setState] = useState({ cardType: "" });
    const [phoneNumber, setPhoneNumber] = useState("");
    const [zipCode, setZipCode] = useState(i18nService.get("ZipCode"));
    const country = i18nService.get("Country");
    const accountInfo = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState._unifiedAccountInfo : null));
    const partnerPhoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );
    const { t: tLang } = useTranslation();

    const { register, handleSubmit, errors, setValue, setError, watch, clearErrors, control } = useForm({
        mode: "onBlur",
        reValidateMode: "onChange",
    });

    const checked = () => {
        if (isEFTChecked) {
            setIsETFChecked(false);
            return;
        }
        setIsETFChecked(true);
    };

    const changeSameAsContactAddress = () => {
        clearInvalidBillingAddress();
        if (isSameAsContactAddress) {
            setIsSameAsContactAddress(false);
            return;
        }
        setIsSameAsContactAddress(true);
    };

    const getAccountOrCardType = () => {
        let accountOrCardType = "";
        if (isETF) {
            accountOrCardType =
                billingInfo && billingInfo.eft && billingInfo.eft.accountType && billingInfo.eft.accountType.selection ? billingInfo.eft.accountType.selection : "";
        } else {
            accountOrCardType =
                billingInfo && billingInfo.creditCard && billingInfo.creditCard.cardType && billingInfo.creditCard.cardType.selection
                    ? billingInfo.creditCard.cardType.selection
                    : "";
            const cardTypeKeyValue = [
                { key: "VISA", value: "Visa" },
                { key: "MASTERCARD", value: "Mastercard" },
                { key: "DISCOVER", value: "Discover" },
                { key: "AMEX", value: "American Express" },
            ];
            const cardObjectWithKeyValue = cardTypeKeyValue.find((card) => card.key === accountOrCardType || card.value === accountOrCardType);
            if (cardObjectWithKeyValue) {
                accountOrCardType = cardObjectWithKeyValue.key;
            }
        }
        return accountOrCardType;
    };

    const getAccountOrCardNumber = () => {
        let accountOrCardType = "";
        if (isETF) {
            accountOrCardType = billingInfo && billingInfo.eft && billingInfo.eft.accountNumber ? billingInfo.eft.accountNumber : "";
        } else {
            accountOrCardType = billingInfo && billingInfo.creditCard && billingInfo.creditCard.cardNumber ? billingInfo.creditCard.cardNumber : "";
        }
        return accountOrCardType;
    };

    const getRoutingNumber = () => {
        let routingNumber = "";
        routingNumber =
            billingInfo && billingInfo.eft && billingInfo.eft.routingNumber && billingInfo.eft.routingNumber.selection
                ? billingInfo.eft.routingNumber.selection
                : "";
        return routingNumber;
    };

    const getBankName = () => {
        let bankName = "";
        bankName = billingInfo && billingInfo.eft && billingInfo.eft.bankName && billingInfo.eft.bankName.selection ? billingInfo.eft.bankName.selection : "";
        return bankName;
    };

    const getAccountName = () => {
        let accountName = "";
        accountName = billingInfo && billingInfo.eft && billingInfo.eft.nameOnAccount ? billingInfo.eft.nameOnAccount : "";
        return accountName;
    };

    const getCashholderName = () => {
        let cashholderName = "";
        cashholderName = billingInfo && billingInfo.creditCard && billingInfo.creditCard.nameOnCard ? billingInfo.creditCard.nameOnCard : "";
        return cashholderName;
    };

    const getSecurityCode = () => {
        let code = "";
        code = billingInfo && billingInfo.creditCard && billingInfo.creditCard.securityCode ? billingInfo.creditCard.securityCode : "";
        return code;
    };

    const getZipCode = () => {
        let code = "";
        code = billingInfo && billingInfo.billingAddress && billingInfo.billingAddress.zipCode ? billingInfo.billingAddress.zipCode : "";
        return code;
    };

    const getAddress1 = () => {
        let address = "";
        address = billingInfo && billingInfo.billingAddress && billingInfo.billingAddress.address1 ? billingInfo.billingAddress.address1 : "";
        return address;
    };

    const getAddress2 = () => {
        let address = "";
        address = billingInfo && billingInfo.billingAddress && billingInfo.billingAddress.address2 ? billingInfo.billingAddress.address2 : "";
        return address;
    };

    const getCity = () => {
        let address = "";
        address = billingInfo && billingInfo.billingAddress && billingInfo.billingAddress.city ? billingInfo.billingAddress.city : "";
        return address;
    };

    const getState = () => {
        let country = "";
        country =
            billingInfo && billingInfo.billingAddress && billingInfo.billingAddress.state && billingInfo.billingAddress.state.selection
                ? billingInfo.billingAddress.state.selection
                : "";
        return country;
    };

    const getRequestETFDetails = (data: any) => {
        if (!isETF) {
            return null;
        }

        const eftDetails = {
            accountType: {
                selection: data.accountType,
            },
            nameOnAccount: data.nameOnAccount,
            routingNumber: {
                selection: data.routingNumber,
            },
            accountNumber: data.accountNumber,
            bankName: {
                selection: data.bankName,
            },
        };

        return eftDetails;
    };

    const getRequestCardDetails = (data: any) => {
        if (isETF) {
            return null;
        }

        const expirationDate = data.expirationDate.split("/");
        const creditCardDetails = {
            CardType: {
                Selection: data.cardType,
            },
            NameOnCard: data.cardholderName?.trimStart(),
            CardNumber: data.cardNumber,
            ExpDateMo: expirationDate[0],
            ExpDateYr: expirationDate[1],
            SecurityCode: data.securityCode,
        };

        return creditCardDetails;
    };

    const formatePhoneNumber = (phoneNumber: string) => {
        let phoneNumberWithoutMasking = phoneNumber;
        phoneNumberWithoutMasking = phoneNumberWithoutMasking.replace(" ", "");
        phoneNumberWithoutMasking = phoneNumberWithoutMasking.replace("(", "");
        phoneNumberWithoutMasking = phoneNumberWithoutMasking.replace(")", "");
        phoneNumberWithoutMasking = phoneNumberWithoutMasking.replace("-", "");
        return phoneNumberWithoutMasking;
    };

    const getRequestBillingAddress = (data: any) => {
        const address1 = isSameAsContactAddress ? contactInfo.address1 : data.address1;
        const address2 = isSameAsContactAddress ? contactInfo.address2 : data.address2;
        const zipcode = isSameAsContactAddress ? contactInfo.zipCode : data.zipcode;
        const state = isSameAsContactAddress ? contactInfo.state : data.state;
        const city = isSameAsContactAddress ? contactInfo.city : data.city;
        const phone = isSameAsContactAddress && contactInfo.phoneNumber ? formatePhoneNumber(contactInfo.phoneNumber) : formatePhoneNumber(data.phone);

        const billingAddress = {
            Address1: address1,
            Address2: address2,
            City: city,
            State: {
                Selection: state,
            },
            ZipCode: zipcode,
            Phone: phone,
        };
        return billingAddress;
    };

    const populateNewBillingInfo = () => {
        service
            .GetPaymentDetail()
            .then((data) => {
                setLoading(false);
                setShowForm(false);
                if (data.isSuccess) {
                    setBillingInfo(data);
                    if (data.paymentMethod && data.paymentMethod.selection) {
                        setHasbillingInfo(true);
                    }
                }
            })
            .catch(() => {
                setLoading(false);
            });
    };

    const onSubmit = (data: any) => {
        let requestBody = {
            BillingAddress: getRequestBillingAddress(data),
            PaymentMode: {
                Selection: isETF ? "EFT" : "CC",
            },
            CreditCardDetails: getRequestCardDetails(data),
            eftDetails: getRequestETFDetails(data),
        };

        setLoading(true);
        service
            .saveBillingInfoUpdateTax(requestBody)
            .then((data) => {
                if (data.isSuccess) {
                    populateNewBillingInfo();

                    Notification({
                        type: "success",
                        title: tLang("manageAccount.myAccount.billing.title"),
                        message: tLang("manageAccount.myAccount.billing.notification.successMsg"),
                        duration: 5,
                    });
                } else if (data.hasError && data.errors && data.errors.length > 0) {
                    setLoading(false);
                    if (data.errors[0] === "Bad Request") {
                        setError("billingAddress", { message: tLang("manageAccount.myAccount.billing.address.validations.invalidBillingAddress") });
                    }
                    Notification({
                        type: "error",
                        title: tLang("manageAccount.myAccount.billing.title"),
                        message: data.errors[0],
                        duration: 5,
                    });
                } else {
                    setLoading(false);
                    Notification({
                        type: "error",
                        title: tLang("manageAccount.myAccount.billing.title"),
                        message: tLang("manageAccount.myAccount.billing.notification.pleaseTryLaterMsg"),
                        duration: 5,
                    });
                }
            })
            .catch(() => {
                setLoading(false);
                Notification({
                    type: "error",
                    title: tLang("manageAccount.myAccount.billing.title"),
                    message: tLang("manageAccount.myAccount.billing.notification.pleaseTryLaterMsg"),
                    duration: 5,
                });
            });
    };

    const clearInvalidBillingAddress = () => {
        if (errors && errors.billingAddress) {
            clearErrors("billingAddress");
        }
    };

    const initaiteCreditCardType = () => {
        let accountOrCardType = "";
        accountOrCardType =
            billingInfo && billingInfo.creditCard && billingInfo.creditCard.cardType && billingInfo.creditCard.cardType.selection
                ? billingInfo.creditCard.cardType.selection
                : "";
        const cardTypeKeyValue = [
            { key: "VISA", value: "Visa" },
            { key: "MASTERCARD", value: "Mastercard" },
            { key: "DISCOVER", value: "Discover" },
            { key: "AMEX", value: "American Express" },
        ];
        const cardObjectWithKeyValue = cardTypeKeyValue.find((card) => card.key === accountOrCardType || card.value === accountOrCardType);
        if (cardObjectWithKeyValue) {
            accountOrCardType = cardObjectWithKeyValue.key;
        }
        setState({ ...state, cardType: accountOrCardType });
    };

    const getSelectedPaymentMethod = () => {
        if (isCreditCardAllowed && isEFTAllowed) {
            return billingInfo && billingInfo.paymentMethod && billingInfo.paymentMethod.selection && billingInfo.paymentMethod.selection === "EFT";
        } else if (isEFTAllowed) {
            return true;
        }

        return false;
    };

    useEffect(() => {
        const isEFT = getSelectedPaymentMethod();
        setIsETF(isEFT);

        if (!isEFT) {
            initaiteCreditCardType();
        }

        const phone = billingInfo && billingInfo.billingAddress && billingInfo.billingAddress.phone ? billingInfo.billingAddress.phone : "";
        setPhoneNumber(phone);
        setValue("phone", phone);
    }, []);

    useEffect(() => {
        clearInvalidBillingAddress();
    }, [watch("phone")]);

    const changeCardType = (event: any) => {
        setState({
            ...state,
            cardType: event.target.value,
        });
        setValue("cardNumber", "");
        setValue("securityCode", "");
    };

    const validateSecurityCode = {
        invalid: (val: any) => {
            if (state.cardType === "AMEX") {
                return /^$|^(\d{4})$/.test(val);
            }
            return /^$|^(\d{3})$/.test(val);
        },
    };

    const validateCreditCardNumber = {
        invalid: (val: any) => {
            if (state.cardType === "AMEX") {
                return /^$|^(\d{15})$/.test(val);
            }
            return /^$|^(\d{16})$/.test(val);
        },
    };

    let expirationDateFieldPressedKey: number;
    const updateExpirationDatePressedKey = (e: any) => {
        expirationDateFieldPressedKey = e.keyCode;
    };
    const toaddMaskToExpiartionDate = (e: any) => {
        e.preventDefault();
        if (e.target.value.length === 2 && expirationDateFieldPressedKey !== 8 && expirationDateFieldPressedKey !== 46) {
            e.target.value = e.target.value + "/";
        }
    };

    useEffect(() => {
        const elements = document.getElementsByClassName("PhoneInputCountry");

        if (elements && elements.length > 0) {
            try {
                for (const el of elements) {
                    const childs = el.children;
                    if (childs[0].nodeName === "SELECT") {
                        const selectEl = childs[0] as HTMLSelectElement;
                        selectEl.disabled = true;
                    }
                }
            } catch { }
        }
    }, []);

    const getBankNameUI = () => {
        if (billingInfo.eft && billingInfo.eft.bankName && billingInfo.eft.bankName.options && billingInfo.eft.bankName.options.length > 0) {
            const options = billingInfo.eft.bankName.options;
            const readOnly = billingInfo.eft.bankName.readOnly ? billingInfo.eft.bankName.readOnly : false;
            if (options.length === 1) {
                return (
                    <div className={`form-row inline row ${errors["bankName"] && "status-error"}`}>
                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                            <label htmlFor="label-bank-name">
                                {tLang("manageAccount.myAccount.billing.info.bank-name")}
                                <span className="required" title="Mandatory">
                                    *
                                </span>
                            </label>
                        </div>
                        <div className="form-input col-xs-12 col-sm-4 col-no-gutter">
                            <input
                                type="text"
                                name="bankName"
                                defaultValue={options[0]}
                                className="inputbox"
                                id="label-bank-name"
                                ref={register({ required: true, maxLength: 30, pattern: /[a-zA-Z0-9s-]/ })}
                                placeholder={tLang("manageAccount.myAccount.billing.info.bank-name")}
                                readOnly={readOnly}
                                maxLength={30}
                                aria-required="true"
                            />
                        </div>
                    </div>
                );
            }

            if (options.length > 1) {
                return (
                    <div className={`form-row inline row ${errors["bankName"] && "status-error"}`}>
                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                            <label htmlFor="label-routing-number">
                                {tLang("manageAccount.myAccount.billing.info.bank-name")}
                                <span className="required" title="Mandatory">
                                    *
                                </span>
                            </label>
                        </div>
                        <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                            <select
                                ref={register({ required: true })}
                                className={errors.bankName ? "status-error inputbox" : "inputbox"}
                                id="edit-bank-name"
                                aria-labelledby="edit-bank-name"
                                name="bankName"
                                defaultValue={getBankName() ? getBankName() : options[0]}
                                aria-required="true"
                            >
                                {options.map((option: string) => {
                                    return (
                                        <option key={option} value={option}>
                                            {option}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>
                    </div>
                );
            }
        }

        return (
            <div className={`form-row inline row ${errors["bankName"] && "status-error"}`}>
                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                    <label htmlFor="label-bank-name">
                        {tLang("manageAccount.myAccount.billing.info.bank-name")}
                        <span className="required" title="Mandatory">
                            *
                        </span>
                    </label>
                </div>
                <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                    <input
                        type="text"
                        name="bankName"
                        defaultValue={getBankName()}
                        className="inputbox"
                        id="label-bank-name"
                        ref={register({ required: true, maxLength: 30, pattern: /[a-zA-Z0-9s-]/ })}
                        placeholder={tLang("manageAccount.myAccount.billing.info.bank-name")}
                        maxLength={30}
                        aria-required="true"
                    />
                    {errors["bankName"] && errors["bankName"].type === "required" && (
                        <span className="form-error">{tLang("manageAccount.myAccount.billing.info.validations.bank-name-required")}</span>
                    )}
                    {errors["bankName"] && errors["bankName"].type === "maxLength" && (
                        <span className="form-error">{tLang("manageAccount.myAccount.billing.info.validations.bank-name-invalid-max-length")}</span>
                    )}
                    {errors["bankName"] && errors["bankName"].type === "pattern" && (
                        <span className="form-error">{tLang("manageAccount.myAccount.billing.info.validations.bank-name-invalid")}</span>
                    )}
                </div>
            </div>
        );
    };

    const getRoutingNumberUI = () => {
        if (billingInfo.eft && billingInfo.eft.routingNumber && billingInfo.eft.routingNumber.options && billingInfo.eft.routingNumber.options.length > 0) {
            const options = billingInfo.eft.routingNumber.options;

            if (options.length >= 1) {
                return (
                    <div className={`form-row inline row ${errors["routingNumber"] && "status-error"}`}>
                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                            <label htmlFor="label-routing-number">
                                {tLang("manageAccount.myAccount.billing.info.routing-number")}
                                <span className="required" title="Mandatory">
                                    *
                                </span>
                            </label>
                        </div>
                        <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                            <select
                                ref={register({ required: true })}
                                className={errors.routingNumber ? "status-error inputbox" : "inputbox"}
                                id="edit-routing-number"
                                aria-labelledby="edit-routing-number"
                                name="routingNumber"
                                defaultValue={getRoutingNumber() ? getRoutingNumber() : options[0]}
                                aria-required="true"
                            >
                                {options.map((option: string) => {
                                    return (
                                        <option key={option} value={option}>
                                            {option}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>
                    </div>
                );
            }
        }

        return (
            <div className={`form-row inline row ${errors["routingNumber"] && "status-error"}`}>
                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                    <label htmlFor="label-routing-number">
                        {tLang("manageAccount.myAccount.billing.info.routing-number")}
                        <span className="required" title="Mandatory">
                            *
                        </span>
                    </label>
                </div>
                <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                    <input
                        type="text"
                        name="routingNumber"
                        defaultValue={getRoutingNumber()}
                        className="inputbox"
                        id="label-routing-number"
                        ref={register({ required: true, maxLength: 9, pattern: /^(\d{9})|$^[0-9]*$/ })}
                        placeholder={tLang("manageAccount.myAccount.billing.info.routing-number")}
                        maxLength={9}
                        aria-required="true"
                    />
                    {errors["routingNumber"] && errors["routingNumber"].type === "required" && (
                        <span className="form-error">{tLang("manageAccount.myAccount.billing.info.validations.routing-number-required")}</span>
                    )}
                    {errors["routingNumber"] && errors["routingNumber"].type === "maxLength" && (
                        <span className="form-error">{tLang("manageAccount.myAccount.billing.info.validations.routing-number-invalid-max-length")}</span>
                    )}
                    {errors["routingNumber"] && errors["routingNumber"].type === "pattern" && (
                        <span className="form-error">{tLang("manageAccount.myAccount.billing.info.validations.routing-number-invalid")}</span>
                    )}
                </div>
            </div>
        );
    };

    const getAccountTypeUI = () => {
        if (billingInfo.eft && billingInfo.eft.accountType && billingInfo.eft.accountType.options && billingInfo.eft.accountType.options.length > 0) {
            const options = billingInfo.eft.accountType.options;
            const readOnly = billingInfo.eft.accountType.readOnly ? billingInfo.eft.accountType.readOnly : false;

            if (options.length === 1) {
                return (
                    <div className={`form-row inline row ${errors["accountType"] && "status-error"}`}>
                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                            <label htmlFor="label-account-type">
                                {tLang("manageAccount.myAccount.billing.info.account-type")}
                                <span className="required" title="Mandatory">
                                    *
                                </span>
                            </label>
                        </div>
                        <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                            <input
                                type="text"
                                name="accountType"
                                defaultValue={options[0]}
                                className="inputbox"
                                id="label-account-type"
                                ref={register({ required: true })}
                                placeholder={tLang("manageAccount.myAccount.billing.info.account-type")}
                                maxLength={20}
                                readOnly={readOnly}
                            />
                        </div>
                    </div>
                );
            }

            if (options.length > 1) {
                return (
                    <div role="alert" className={`form-row inline row ${errors["accountType"] && "status-error"}`}>
                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                            <label htmlFor="edit-account-type">
                                {tLang("manageAccount.myAccount.billing.info.account-type")}
                                <span className="required" title="Mandatory">
                                    *
                                </span>
                            </label>
                        </div>
                        <div className="form-input col-xs-12 col-sm-4 col-no-gutter">
                            <select
                                ref={register({ required: true })}
                                className={errors.accountType ? "status-error inputbox" : "inputbox"}
                                id="edit-account-type"
                                aria-labelledby="edit-account-type"
                                name="accountType"
                                defaultValue={getAccountOrCardType() ? getAccountOrCardType() : options[0]}
                            >
                                {options.map((option: string) => {
                                    return (
                                        <option key={option} value={option}>
                                            {option}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>
                    </div>
                );
            }
        }

        return (
            <div className={`form-row inline row ${errors["accountType"] && "status-error"}`}>
                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                    <label htmlFor="label-accountType">
                        {tLang("manageAccount.myAccount.billing.info.account-type")}
                        <span className="required" title="Mandatory">
                            *
                        </span>
                    </label>
                </div>
                <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                    <input
                        type="text"
                        name="accountType"
                        defaultValue={getAccountOrCardType()}
                        className="inputbox"
                        id="label-accountType"
                        ref={register({ required: true, maxLength: 20 })}
                        placeholder={tLang("manageAccount.myAccount.billing.info.account-type")}
                        maxLength={20}
                    />
                    {errors["accountType"] && errors["accountType"].type === "required" && (
                        <span className="form-error">{tLang("manageAccount.myAccount.billing.info.validations.account-type-required")}</span>
                    )}
                    {errors["accountType"] && errors["accountType"].type === "maxLength" && (
                        <span className="form-error">{tLang("manageAccount.myAccount.billing.info.validations.account-type-invalid")}</span>
                    )}
                </div>
            </div>
        );
    };

    console.log('zipCode in Non IDF billing', zipCode);

    return (
        <div id="billing-info-form" className={`${loading && "loading"}`}>
            <form onSubmit={handleSubmit(onSubmit)} id="billing-info-form-container">
                {/*payment method option*/}
                {/*<fieldset className="form-row inline">*/}
                    <div className="form-row inline row">
                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                            <legend className="legend-label"> <label className="form-radio-label" htmlFor="payment_method_billingType_credit">{tLang("manageAccount.myAccount.billing.label.paymentMethod")}</label></legend>
                        </div>

                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                            {isCreditCardAllowed && (
                                <div className="row ">
                                    <div className="col-xs-12 col-no-gutter">
                                        <div className="form-row row">
                                            <label className="form-radio-label" htmlFor="payment_method_billingType_credit">
                                                <input
                                                    type="radio"
                                                    id="payment_method_billingType_credit"
                                                    name="payment_method_billingType"
                                                    value={CC}
                                                    onChange={() => { }}
                                                    onClick={() => setIsETF(false)}
                                                    checked={!isETF}
                                                />
                                                <span className="form-radio-label-text">{tLang("manageAccount.myAccount.billing.info.credit-card")}</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {isEFTAllowed && (
                                <div className="row ">
                                    <div className="col-xs-12 col-no-gutter">
                                        <div className="form-row row">
                                            <label className="form-radio-label" htmlFor="payment_method_billingType_eft">
                                                <input
                                                    type="radio"
                                                    id="payment_method_billingType_eft"
                                                    name="payment_method_billingType"
                                                    value={EFT}
                                                    onChange={() => { }}
                                                    onClick={() => setIsETF(true)}
                                                    checked={isETF}
                                                />
                                                <span className="form-radio-label-text">
                                                    {tLang("manageAccount.myAccount.billing.info.electronic-funds-transfer")}
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                {/*</fieldset>*/}

                {billingInfo.customMessage && <BillingInformationCustomMessage customMessage={billingInfo.customMessage} />}

                {!isETF && (
                    <React.Fragment>
                        <div className={`form-row inline row ${errors["cardholderName"] && "status-error"}`}>
                            <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                <label htmlFor="label-cardholderName">
                                    {tLang("manageAccount.myAccount.billing.info.card-name")}
                                    <span className="required" title="Mandatory">
                                        *
                                    </span>
                                </label>
                            </div>
                            <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                <input
                                    aria-required="true"
                                    type="text"
                                    name="cardholderName"
                                    defaultValue={getCashholderName()}
                                    className="inputbox"
                                    id="label-cardholderName"
                                    ref={register({ required: true, pattern: PATTERNS.CARDHOLDERNAME.pattern, maxLength: 30 })}
                                    maxLength={30}
                                    placeholder=""
                                />
                                {errors["cardholderName"] && errors["cardholderName"].type === "required" && (
                                    <span className="form-error">{tLang("manageAccount.myAccount.billing.info.validations.card-name-required")}</span>
                                )}
                                {errors["cardholderName"] && errors["cardholderName"].type === "pattern" && (
                                    <span className="form-error">{PATTERNS.CARDHOLDERNAME.message}</span>
                                )}
                                {errors["cardholderName"] && errors["cardholderName"].type === "maxLength" && (
                                    <span className="form-error">{tLang("manageAccount.myAccount.billing.info.validations.card-holder-pattern")}</span>
                                )}
                            </div>
                        </div>

                        <div className={`form-row inline row ${errors["cardType"] && "status-error"}`}>
                            <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                <label htmlFor="edit-card-type">
                                    {tLang("manageAccount.myAccount.billing.info.card-type")}
                                    <span className="required" title="Mandatory">
                                        *
                                    </span>
                                </label>
                            </div>
                            <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                <select
                                    aria-required="true"
                                    ref={register({ required: true })}
                                    className={errors.cardType ? "status-error inputbox" : "inputbox"}
                                    id="edit-card-type"
                                    aria-labelledby="edit-card-type"
                                    name="cardType"
                                    defaultValue={getAccountOrCardType()}
                                    onChange={changeCardType}
                                >
                                    <option value="">--</option>
                                    <option value="VISA">Visa</option>
                                    <option value="MASTERCARD">Mastercard</option>
                                    <option value="DISCOVER">Discover</option>
                                    <option value="AMEX">American Express</option>
                                </select>
                                {errors.cardType && (
                                    <span className="form-error">
                                        <p>{tLang("manageAccount.myAccount.billing.info.validations.card-type-reruired")}</p>
                                    </span>
                                )}
                            </div>
                        </div>

                        <div className={`form-row inline row ${errors["cardNumber"] && "status-error"}`}>
                            <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                <label htmlFor="label-card-number">
                                    {tLang("manageAccount.myAccount.billing.info.card-number")}
                                    <span className="required" title="Mandatory">
                                        *
                                    </span>
                                </label>
                            </div>
                            <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                <input
                                    aria-required="true"
                                    type="text"
                                    name="cardNumber"
                                    defaultValue=""
                                    className="inputbox"
                                    id="label-card-number"
                                    ref={register({ required: true, validate: validateCreditCardNumber })}
                                    maxLength={state.cardType === "AMEX" ? 15 : 16}
                                    placeholder={tLang("manageAccount.myAccount.billing.info.card-number")}
                                />
                                {errors["cardNumber"] && errors["cardNumber"].type === "required" && (
                                    <span className="form-error">{tLang("manageAccount.myAccount.billing.info.validations.card-number-required")}</span>
                                )}
                                {errors["cardNumber"] && errors["cardNumber"].type === "pattern" && (
                                    <span className="form-error">{tLang("manageAccount.myAccount.billing.info.validations.card-number-invalid")}</span>
                                )}
                                {errors["cardNumber"] && errors["cardNumber"].type === "invalid" && (
                                    <span className="form-error">
                                        {tLang("manageAccount.myAccount.billing.info.validations.card-number-invalid")}{" "}
                                        {tLang("manageAccount.myAccount.billing.info.validations.card-number-invalid-text2")}{" "}
                                        {state.cardType === "AMEX" ? "15" : "16"}{" "}
                                        {tLang("manageAccount.myAccount.billing.info.validations.card-number-invalid-text3")}
                                    </span>
                                )}
                            </div>
                        </div>

                        <div className={`form-row inline row ${errors["expirationDate"] && "status-error"}`}>
                            <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                <label htmlFor="label-expiration-date">
                                    {tLang("manageAccount.myAccount.billing.info.expiry-date")}
                                    <span className="required" title="Mandatory">
                                        *
                                    </span>
                                </label>
                            </div>
                            <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                <input
                                    aria-required="true"
                                    type="text"
                                    name="expirationDate"
                                    defaultValue=""
                                    className="inputbox"
                                    id="label-expiration-date"
                                    placeholder="MM/YY"
                                    maxLength={5}
                                    ref={register({
                                        required: true,
                                        maxLength: 5,
                                        pattern: /(0[1-9]|1[012])[/]([0-9][1-9]|[1-9][0-9])/,
                                        validate: (value) => {
                                            if (value.length === 5) {
                                                const expireDate = value.split("/");
                                                return validateCardExpiry(expireDate[0], expireDate[1]);
                                            }
                                            return true;
                                        },
                                    })}
                                    onKeyDown={updateExpirationDatePressedKey}
                                    onChange={toaddMaskToExpiartionDate}
                                />
                                {errors["expirationDate"] && errors["expirationDate"].type === "required" && (
                                    <span className="form-error">{tLang("manageAccount.myAccount.billing.info.validations.card-expdate-required")}</span>
                                )}
                                {errors["expirationDate"] && errors["expirationDate"].type === "maxLength" && (
                                    <span className="form-error">{tLang("manageAccount.myAccount.billing.info.validations.card-expdate-max-length")}</span>
                                )}
                                {errors["expirationDate"] && errors["expirationDate"].type === "pattern" && (
                                    <span className="form-error">{tLang("manageAccount.myAccount.billing.info.validations.card-expdate-invalid")}</span>
                                )}
                                {errors["expirationDate"] && errors["expirationDate"].type === "validate" && (
                                    <span className="form-error">
                                        {tLang("manageAccount.myAccount.billing.info.validations.card-expdate-invalid-date")} {partnerPhoneNumber}
                                    </span>
                                )}
                            </div>
                        </div>
                        <div className={`form-row inline row ${errors["securityCode"] && "status-error"}`}>
                            <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                <label htmlFor="label-security-code">
                                    {tLang("manageAccount.myAccount.billing.info.security-code")}
                                    <span className="required" title="Mandatory">
                                        *
                                    </span>
                                </label>
                            </div>
                            <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                <input
                                    aria-required="true"
                                    type="password"
                                    name="securityCode"
                                    defaultValue={getSecurityCode()}
                                    className="inputbox"
                                    id="label-security-code"
                                    ref={register({ required: true, validate: validateSecurityCode })}
                                    maxLength={state.cardType === "AMEX" ? 4 : 3}
                                    placeholder="CVV"
                                />
                                {errors["securityCode"] && errors["securityCode"].type === "required" && (
                                    <span className="form-error">{tLang("manageAccount.myAccount.billing.info.validations.security-code-required")}</span>
                                )}
                                {errors["securityCode"] && errors["securityCode"].type === "invalid" && (
                                    <span className="form-error">
                                        {tLang("manageAccount.myAccount.billing.info.validations.security-code-invalid-text1")}{" "}
                                        {tLang("manageAccount.myAccount.billing.info.validations.security-code-invalid-text2")}{" "}
                                        {state.cardType === "AMEX" ? "4" : "3"}{" "}
                                        {tLang("manageAccount.myAccount.billing.info.validations.security-code-invalid-text3")}
                                    </span>
                                )}
                            </div>
                        </div>
                    </React.Fragment>
                )}

                {isETF && (
                    <React.Fragment>
                        <div className={`form-row inline row ${errors["nameOnAccount"] && "status-error"}`}>
                            <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                <label htmlFor="label-name-on-account">
                                    {tLang("manageAccount.myAccount.billing.info.name-on-account")}
                                    <span className="required" title="Mandatory">
                                        *
                                    </span>
                                </label>
                            </div>
                            <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                <input
                                    type="text"
                                    name="nameOnAccount"
                                    defaultValue={getAccountName()}
                                    className="inputbox"
                                    id="label-name-on-account"
                                    ref={register({ required: true, maxLength: 30, pattern: /^[a-zA-Z-'\s.]+$/ })}
                                    placeholder={tLang("manageAccount.myAccount.billing.info.name-on-account")}
                                    maxLength={30}
                                    aria-required="true"
                                />
                                {errors["nameOnAccount"] && errors["nameOnAccount"].type === "required" && (
                                    <span className="form-error">{tLang("manageAccount.myAccount.billing.info.validations.name-on-account-required")}</span>
                                )}
                                {errors["nameOnAccount"] && errors["nameOnAccount"].type === "maxLength" && (
                                    <span className="form-error">
                                        {tLang("manageAccount.myAccount.billing.info.validations.name-on-account-invalid-max-length")}
                                    </span>
                                )}
                                {errors["nameOnAccount"] && errors["nameOnAccount"].type === "pattern" && (
                                    <span className="form-error">{tLang("manageAccount.myAccount.billing.info.validations.name-on-account-invalid")}</span>
                                )}
                            </div>
                        </div>

                        {getBankNameUI()}
                        {getRoutingNumberUI()}

                        {/*Account Number*/}
                        <div className={`form-row inline row ${errors["accountNumber"] && "status-error"}`}>
                            <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                <label htmlFor="label-accountNumber">
                                    {tLang("manageAccount.myAccount.billing.info.account-number")}
                                    <span className="required" title="Mandatory">
                                        *
                                    </span>
                                </label>
                            </div>

                            <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                <input
                                    type="text"
                                    name="accountNumber"
                                    defaultValue={getAccountOrCardNumber()}
                                    className="inputbox"
                                    id="label-accountNumber"
                                    ref={register({ required: true, pattern: /^$|^(\d{4,36})$/ })}
                                    placeholder={tLang("manageAccount.myAccount.billing.info.account-number")}
                                    aria-required="true"
                                />
                                {errors["accountNumber"] && errors["accountNumber"].type === "required" && (
                                    <span className="form-error">{tLang("manageAccount.myAccount.billing.info.validations.account-number-required")}</span>
                                )}
                                {errors["accountNumber"] && errors["accountNumber"].type === "pattern" && (
                                    <span className="form-error">{tLang("manageAccount.myAccount.billing.info.validations.account-number-invalid")}</span>
                                )}
                            </div>
                        </div>

                        {getAccountTypeUI()}

                        <div className={`form-row inline row ${errors["isEFTChecked"] && "status-error"}`}>
                            <div className="form-label col-xs-12 col-sm-8 col-no-gutter">
                                <div className="form-row no-margin">
                                    <div className="form-input">
                                        <label className="form-checkbox-label" htmlFor="isEFTChecked">
                                            <input
                                                aria-required="true"
                                                type="checkbox"
                                                id="isEFTChecked"
                                                name="isEFTChecked"
                                                ref={register({ required: true })}
                                                onChange={() => checked()}
                                                checked={isEFTChecked}
                                            />
                                            <span className="form-checkbox-label-text">
                                                {tLang("manageAccount.myAccount.billing.authorizeTheUseText1")}{" "}
                                                <span onClick={() => setEFTDialog(true)} className="default_link">
                                                    <a href="javascript:void(0)" className="default_link">
                                                        {tLang("manageAccount.myAccount.billing.authorizeTheUseText2")}
                                                    </a>
                                                </span>{" "}
                                                {tLang("manageAccount.myAccount.billing.authorizeTheUseText3")}
                                            </span>
                                        </label>
                                        {errors["isEFTChecked"] && errors["isEFTChecked"].type === "required" && (
                                            <span role="alert" className="form-error">
                                                {tLang("manageAccount.myAccount.billing.youMustAuthorize")}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                )}

                {/*billing address*/}
                <div className="form-row inline row">
                    <div className="form-label col-xs-12 col-sm-8 col-no-gutter">
                        <div className="line-divider" style={{ marginTop: "1.5rem" }}></div>
                    </div>
                </div>
                <div className="box" style={{ marginLeft: "2rem" }}>
                    <div className="box-header">
                        <div className="box-title-container">
                            <div className="box-title-icon" aria-hidden="true">
                                <RenderIcons iconName="map-marker" />
                            </div>
                            <div className="box-title-text has-actions">
                                <h3 className="box-title">{tLang("manageAccount.myAccount.billing.address.title")}</h3>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={`form-row inline row`}>
                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                        <label htmlFor="sameAsContact"> {tLang("manageAccount.myAccount.billing.address.title")}</label>
                    </div>
                    <div className="form-input col-xs-12 col-sm-4 col-no-gutter">
                        <div className="form-row">
                            <div className="form-input">
                                <label className="form-checkbox-label" htmlFor="sameAsContact">
                                    <input type="checkbox" id="sameAsContact" name="sameAsContact" onChange={() => changeSameAsContactAddress()} checked={isSameAsContactAddress} />
                                    <span className="form-checkbox-label-text">{tLang("manageAccount.myAccount.billing.address.same")}</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                {!isSameAsContactAddress && (
                    <React.Fragment>
                        {/*<fieldset className="form-row no-margin inline">*/}
                            <div className="form-row no-margin inline row">
                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                    <legend className="legend-label">
                                        <label htmlFor="label-address-line-1">
                                        {tLang("manageAccount.myAccount.billing.address.street")}
                                        <span className="required" title="Mandatory">
                                            *
                                            </span>
                                            </label>
                                    </legend>
                                </div>

                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div role="alert" className={`form-row row ${errors["address1"] && "status-error"}`}>
                                        <div className="form-label sr-only col-xs-12 col-no-gutter">
                                            <label htmlFor="label-address-line1">
                                                {tLang("manageAccount.myAccount.billing.address.address-1")}
                                                <span className="required" title="Mandatory">
                                                    *
                                                </span>
                                            </label>
                                        </div>
                                        <div role="alert" className="form-input col-xs-12 col-no-gutter">
                                            <input
                                                type="text"
                                                onChange={clearInvalidBillingAddress}
                                                defaultValue={getAddress1()}
                                                name="address1"
                                                className="inputbox"
                                                id="label-address-line-1"
                                                ref={register({ required: true, pattern: PATTERNS.STREETADDRESS.pattern })}
                                                placeholder=""
                                                aria-required="true"
                                            />
                                            {errors["address1"] && errors["address1"].type === "required" && (
                                                <span className="form-error">{tLang("manageAccount.myAccount.billing.address.validations.address1.required")}</span>
                                            )}
                                            {errors["address1"] && errors["address1"].type === "pattern" && (
                                                <span className="form-error">{PATTERNS.STREETADDRESS.message}</span>
                                            )}
                                        </div>
                                    </div>
                                    <div role="alert" className={`form-row row ${errors["address2"] && "status-error"}`}>
                                        <div className="form-label sr-only col-xs-12 col-no-gutter">
                                            <label htmlFor="label-address-line-2">{tLang("manageAccount.myAccount.billing.address.address-2")}</label>
                                        </div>
                                        <div role="alert" className="form-input col-xs-12 col-no-gutter">
                                            <input
                                                type="text"
                                                onChange={clearInvalidBillingAddress}
                                                defaultValue={getAddress2()}
                                                name="address2"
                                                className="inputbox"
                                                id="label-address-line-2"
                                                ref={register({ pattern: PATTERNS.STREETADDRESS.pattern })}
                                                placeholder=""
                                            />
                                            {errors["address2"] && errors["address2"].type === "pattern" && (
                                                <span className="form-error">{PATTERNS.STREETADDRESS.message}</span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        {/*</fieldset>*/}

                        <div role="alert" className={`form-row inline row ${errors["city"] && "status-error"}`}>
                            <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                <label htmlFor="label-address-city">
                                    {tLang("manageAccount.myAccount.billing.address.city")}
                                    <span className="required" title="Mandatory">
                                        *
                                    </span>
                                </label>
                            </div>
                            <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                <input
                                    type="text"
                                    name="city"
                                    onChange={clearInvalidBillingAddress}
                                    defaultValue={getCity()}
                                    className="inputbox"
                                    id="label-address-city"
                                    ref={register({ required: true, pattern: /^[a-zA-Z.\s]+$/ })}
                                    placeholder=""
                                    aria-required="true"
                                />
                                {errors["city"] && errors["city"].type === "required" && (
                                    <span className="form-error">{tLang("manageAccount.myAccount.billing.address.validations.city.required")}</span>
                                )}
                                {errors["city"] && errors["city"].type === "pattern" && (
                                    <span className="form-error">{tLang("manageAccount.myAccount.billing.address.validations.city.pattern")}</span>
                                )}
                            </div>
                        </div>
                        {country === "US" ? (
                            <div className={`form-row inline row ${errors["state"] && "status-error"}`}>
                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                    <label htmlFor="label-address-state">
                                        {tLang("manageAccount.myAccount.billing.address.state")}
                                        <span className="required" title="Mandatory">
                                            *
                                        </span>
                                    </label>
                                </div>
                                <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                    <select
                                        className="inputbox"
                                        onChange={clearInvalidBillingAddress}
                                        id="label-address-state"
                                        defaultValue={getState()}
                                        name="state"
                                        ref={register({ required: true, pattern: /^[a-zA-Z.\s]+$/ })}
                                        aria-required="true"
                                    >
                                        {stateList.map((val: any) => (
                                            <option key={val.name} value={val.value}>
                                                {val.name}
                                            </option>
                                        ))}
                                    </select>
                                    {errors["state"] && errors["state"].type === "pattern" && (
                                        <span className="form-error">{tLang("manageAccount.myAccount.billing.address.validations.state.required")}</span>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <>
                                {country === "CA" ? (
                                    <div className={`form-row inline row ${errors["state"] && "status-error"}`}>
                                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                            <label htmlFor="label-address-state">
                                                {tLang("manageAccount.myAccount.billing.address.province")}
                                                <span className="required" title="Mandatory">
                                                    *
                                                </span>
                                            </label>
                                        </div>
                                        <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                            <select
                                                className="inputbox"
                                                id="label-address-state"
                                                onChange={clearInvalidBillingAddress}
                                                name="state"
                                                defaultValue={getState()}
                                                ref={register({ required: true, pattern: /^[a-zA-Z.\s]+$/ })}
                                                aria-required="true"
                                            >
                                                {CAProvinces.map((val: any) => (
                                                    <option key={val.name} value={val.value}>
                                                        {val.name}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors["state"] && errors["state"].type === "pattern" && (
                                                <span className="form-error">{tLang("manageAccount.myAccount.billing.address.validations.province.required")}</span>
                                            )}
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        {billingInfo && (
                                            <div className={`form-row inline row ${errors["state"] && "status-error"}`}>
                                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                                    <label htmlFor="label-address-state">
                                                        {tLang("manageAccount.myAccount.billing.address.region")}
                                                        <span className="required" title="Mandatory">
                                                            *
                                                        </span>
                                                    </label>
                                                </div>
                                                <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                                    <input
                                                        type="text"
                                                        name="state"
                                                        defaultValue={getState()}
                                                        ref={register({ required: true, pattern: PATTERNS.REGION.pattern })}
                                                        className="inputbox"
                                                        id="label-address-state"
                                                        onChange={clearInvalidBillingAddress}
                                                        aria-required="true"
                                                    />
                                                    {errors["state"] && errors["state"].type === "required" && (
                                                        <span className="form-error">
                                                            {tLang("manageAccount.myAccount.billing.address.validations.region.required")}
                                                        </span>
                                                    )}
                                                    {errors["state"] && errors["state"].type === "pattern" && (
                                                        <span className="form-error">
                                                            {tLang("manageAccount.myAccount.billing.address.validations.region.pattern")}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </>
                                )}
                            </>
                        )}

                        <div className={`form-row inline row ${errors["zipcode"] && "status-error"}`}>
                            <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                <label htmlFor="label-address-zipcode">
                                    {zipCode.Label === "Zip Code"
                                        ? tLang("manageAccount.myAccount.billing.address.zip")
                                        : tLang("manageAccount.myAccount.billing.address.postalCode")}
                                    <span className="required" title="Mandatory">
                                        *
                                    </span> &nbsp;
                                </label>
                            </div>
                            <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                <input
                                    type="text"
                                    onChange={clearInvalidBillingAddress}
                                    className="inputbox"
                                    id="label-address-zipcode"
                                    defaultValue={getZipCode()}
                                    name="zipcode"
                                    ref={register({ required: true, pattern: PATTERNS[zipCode.Pattern].pattern })}
                                    maxLength={zipCode.MaxLength}
                                    placeholder={
                                        zipCode.Label === "Zip Code"
                                            ? tLang("manageAccount.myAccount.billing.address.zip")
                                            : tLang("manageAccount.myAccount.billing.address.postalCode")
                                    }
                                    aria-required="true"
                                />
                                {errors["zipcode"] && errors["zipcode"].type === "required" && (
                                    <span className="form-error">
                                        {zipCode.Label === "Zip Code"
                                            ? tLang("manageAccount.myAccount.billing.address.validations.zip.required")
                                            : tLang("manageAccount.myAccount.billing.address.validations.postalCode.required")}
                                    </span>
                                )}
                                {errors["zipcode"] && errors["zipcode"].type === "pattern" && (
                                    <span className="form-error">
                                        {tLang("manageAccount.myAccount.billing.address.validations.zip.invalid")} {zipCode.Label}{" "}
                                        {tLang("manageAccount.myAccount.billing.address.validations.zip.pattern")}
                                    </span>
                                )}
                            </div>
                        </div>

                        <div className={`form-row inline row ${errors["phone"] && "status-error"}`}>
                            <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                <label htmlFor="label-phone-number1">
                                    {tLang("manageAccount.myAccount.billing.address.phone")}
                                    <span className="required" title="Mandatory">
                                        *
                                    </span>
                                </label>
                            </div>
                            <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                {billingInfo && (
                                    <>
                                        <Controller
                                            name={`phone`}
                                            control={control}
                                            defaultValue={phoneNumber}
                                            className="inputbox"
                                            rules={{
                                                required: true,
                                                validate: (value) =>
                                                    value ? isValidPhoneNo(accountInfo && accountInfo.country ? accountInfo.country : "US", value) : false,
                                            }}
                                            render={({ onChange, value }) => (
                                                <PhoneInput
                                                    value={value}
                                                    onChange={onChange}
                                                    international={false}
                                                    addInternationalOption={false}
                                                    className="inputbox"
                                                    defaultCountry={accountInfo && accountInfo.country ? accountInfo.country : "US"}
                                                    countries={[accountInfo && accountInfo.country ? accountInfo.country : "US"]}
                                                    id={"label-phone-number1"}
                                                    placeholder={tLang("manageAccount.myAccount.billing.address.placeholder.primaryPhone")}
                                                    maxLength={15}
                                                    minLength={10}
                                                    aria-required="true"
                                                />
                                            )}
                                        />
                                        {errors["phone"] && errors["phone"].type === "required" && (
                                            <span className="form-error">{tLang("manageAccount.myAccount.billing.address.validations.phone.required")}</span>
                                        )}
                                        {errors["phone"] && errors["phone"].type === "validate" && (
                                            <span className="form-error">
                                                {tLang("manageAccount.myAccount.billing.address.validations.phone.phoneNumberInvalidText1")}{" "}
                                                {watch("phone") && !parsePhoneNumber(watch("phone")) && (
                                                    <span>{tLang("manageAccount.myAccount.billing.address.validations.phone.phoneNumberInvalidText2")}</span>
                                                )}
                                                {tLang("manageAccount.myAccount.billing.address.validations.phone.phoneNumberInvalidText3")}
                                            </span>
                                        )}
                                        {errors["phone"] && errors["phone"].type === "minLength" && (
                                            <span className="form-error">
                                                {tLang("manageAccount.myAccount.billing.address.validations.phone.phoneNumberInvalid")}
                                            </span>
                                        )}
                                        {errors["phone"] && errors["phone"].type === "maxLength" && (
                                            <span className="form-error">
                                                {tLang("manageAccount.myAccount.billing.address.validations.phone.phoneNumberInvalid")}
                                            </span>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    </React.Fragment>
                )}

                {isSameAsContactAddress && !contactInfo.phoneNumber && (
                    <div className={`form-row inline row ${errors["phone"] && "status-error"}`}>
                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                            <label htmlFor="label-phone-number">
                                {tLang("manageAccount.myAccount.billing.address.phone")}
                                <span className="required" title="Mandatory">
                                    *
                                </span>
                            </label>
                        </div>
                        <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                            {billingInfo && (
                                <>
                                    <Controller
                                        name={`phone`}
                                        control={control}
                                        defaultValue={phoneNumber}
                                        className="inputbox"
                                        rules={{
                                            required: true,
                                            validate: (value) => (value ? isValidPhoneNo(country ? country : "US", value) : false),
                                        }}
                                        render={({ onChange, value }) => (
                                            <PhoneInput
                                                value={value}
                                                onChange={onChange}
                                                international={false}
                                                addInternationalOption={false}
                                                className="inputbox"
                                                defaultCountry={country}
                                                countries={[country]}
                                                id={"label-phone-number"}
                                                placeholder={tLang("manageAccount.myAccount.billing.address.placeholder.primaryPhone")}
                                                maxLength={15}
                                                minLength={10}
                                                aria-required="true"
                                            />
                                        )}
                                    />

                                    {errors["phone"] && errors["phone"].type === "required" && (
                                        <span className="form-error">{tLang("manageAccount.myAccount.billing.address.validations.phone.required")}</span>
                                    )}
                                    {errors["phone"] && errors["phone"].type === "validate" && (
                                        <span className="form-error">
                                            {tLang("manageAccount.myAccount.billing.address.validations.phone.phoneNumberInvalidText1")}{" "}
                                            {watch("phone") && !parsePhoneNumber(watch("phone")) && (
                                                <span>{tLang("manageAccount.myAccount.billing.address.validations.phone.phoneNumberInvalidText2")}</span>
                                            )}
                                            {tLang("manageAccount.myAccount.billing.address.validations.phone.phoneNumberInvalidText3")}
                                        </span>
                                    )}
                                    {errors["phone"] && errors["phone"].type === "minLength" && (
                                        <span className="form-error">{tLang("manageAccount.myAccount.billing.address.validations.phone.phoneNumberInvalid")}</span>
                                    )}
                                    {errors["phone"] && errors["phone"].type === "maxLength" && (
                                        <span className="form-error">{tLang("manageAccount.myAccount.billing.address.validations.phone.phoneNumberInvalid")}</span>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                )}

                {errors["billingAddress"] && (
                    <fieldset role="alert" className="form-row inline">
                        <div className="row">
                            <div className="col-xs-12 col-sm-4 col-no-gutter"></div>
                            <div className="col-xs-12 col-sm-8 col-no-gutter">
                                <span className="form-error">{errors.billingAddress.message}</span>
                            </div>
                        </div>
                    </fieldset>
                )}

                <div className="margin-vertical-l"></div>

                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null"></div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <ul className="list-inline list-reset">
                            <li>
                                <button
                                    type="button"
                                    onClick={() => {
                                        setShowForm(false);
                                    }}
                                    className="btn-default btn-link btn-no-padding btn-no-border btn-min-width"
                                >
                                    <span className="btn-text">{tLang("manageAccount.myAccount.billing.cancelButtonText")}</span>
                                </button>
                            </li>
                            <li className="margin-left-s">
                                <button type="submit" className="btn-default btn-primary btn-min-width">
                                    <span className="btn-text">{tLang("manageAccount.myAccount.billing.saveButtonText")}</span>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default BillingInformationForm;
